import { render, staticRenderFns } from "./MiniappshaichaVisionScreeningUserSub.vue?vue&type=template&id=8163d25a&scoped=true&"
import script from "./MiniappshaichaVisionScreeningUserSub.vue?vue&type=script&lang=js&"
export * from "./MiniappshaichaVisionScreeningUserSub.vue?vue&type=script&lang=js&"
import style0 from "./MiniappshaichaVisionScreeningUserSub.vue?vue&type=style&index=0&id=8163d25a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8163d25a",
  null
  
)

export default component.exports